// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Loading from 'react-loading';
import Markdown from 'react-markdown/with-html';

import Search from '../Search';
import api from '../../api';

import '../../styles/automate.css';

export default class Automate extends React.Component {

    state = {
        filter: "",
        loading: true
    }

    componentDidMount = async () => {
        // Load modules
        const res = await api.get('/module/all');

        let modules = [];
        if (res && res.success && res.modules)
            modules = res.modules;
        await this.props.setModules(modules);
        await this.setState({ loading: false });

        this.props.loadStacks();
    }

    getModuleFilter = (m) => (m.name.toLowerCase() + " " + m.description.toLowerCase() + " " + m.creatorName.toLowerCase()).includes(this.state.filter.toLowerCase())

    openAttachModal = (m) => {
        const stackId = this.props.match.params.stackId;
        if (stackId)
            this.props.modal("automate-configure", {
                module: m,
                stack: this.props.stacks.find(s => s._id === stackId),
                reload: this.loadStacks,
                goToStack: true
            });

        else this.props.modal("automate-attach-marketplace", {
            module: m,
            stacks: this.props.stacks,
            modules: this.props.modules,
            reload: this.loadStacks
        });
    }

    renderModule = (m) => (<div
        className="automate-module"
        style={{
            backgroundImage: "url('" + m.icon + "')"
        }}
        title={m.name}
        onClick={() => this.openAttachModal(m)}
    >
        {!m.rate && <div
            className="automate-module-free"
        >Free</div>}
        <h3>{m.name}</h3>
        <h4>{m.creatorName}</h4>
        <Markdown
            source={m.description}
            escapeHtml={false}
        />
    </div>);

    render = () => {
        const featured = this.props.modules.filter(m => m.feature && this.getModuleFilter(m));
        const featuredIds = featured.map(f => f._id);

        const remaining = this.props.modules.filter(m => !featuredIds.includes(m._id) && this.getModuleFilter(m));

        return (<>
            {/* <div className="automate-header" /> */}
            <div className="settings-content automate-content">
                {/* <h1><strong>Automate</strong> your document workflow</h1> */}
                <p>
                    Use Stax<span className="stax-dot-small" />ai <strong>modules</strong> to extract data from pre-defined forms, send emails or messages upon receiving documents, send your document or extracted data to <strong>2,000+ other apps</strong>, make API requests, and <i>much more!</i> Modules can be <strong>attached</strong> to your team's stacks such that it is triggered when a document is classified into that stack. Modules can also be <strong>stacked</strong> to have multiple steps in your workflow automation pipeline.
                </p>

                {/* Search for modules */}
                <div style={{
                    width: '100%',
                    height: 40,
                    marginTop: 30,
                    marginLeft: -20
                }}>
                    <Search
                        user={this.props.user}
                        query={this.state.filter}
                        search={filter => this.setState({ filter })}
                        className="title-input"
                        placeholder="Search for a module..."
                        style={{ width: 225 }}
                    />
                </div>

                {this.state.loading && <div style={{
                    paddingTop: 40
                }}><Loading
                    type="bubbles"
                    color="var(--color-primary-dark)"
                    height={80}
                    width={80}
                /></div>}

                {/* Featured Modules */}
                {featured.length > 0 && <>
                    <h2>Featured Modules</h2>
                    {featured.map((f,idx) => <div
                        key={idx}
                        className="automate-featured"
                        title={f.name}
                        onClick={() => this.openAttachModal(f)}
                    >
                        <img
                            className="automate-featured-feature"
                            src={f.feature}
                            alt={f.name}
                        />
                        {this.renderModule(f)}
                    </div>)}
                    <div style={{ clear: 'both' }} />
                </>}

                {/* Remaining modules */}
                {remaining.length > 0 && <>
                    <h2 style={{ paddingTop: 10 }}>Automation Modules</h2>
                    {remaining.map((r,idx) => <div
                        key={idx}
                        className="automate-remaining"
                        title={r.name}    
                    >{this.renderModule(r)}</div>)}
                </>}

                <div style={{ clear: 'both', height: 20 }} />
            </div>
        </>);
    }

};